<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="shadow_bar">
        <div
          class="close"
          @click="deleteQuestion"
        >
          <i
            style="margin-bottom: 7px"
            class="fa fa-times f10"
          ></i>
        </div>
        <div class="card card-body">
          <label>Pergunta</label>
          <input
            v-model="question.title"
            type="text"
            class="form-control"
            placeholder="PERGUNTA NA QUAL O CANDIDATO(A) DEVE RESPONDER"
            :class="{
              'is-invalid': $v.question.title.$error,
              'is-valid': !$v.question.title.$invalid,
            }"
            :field="$v.question.title"
          />
          <input
            type="text"
            class="mt-3 form-control"
            placeholder="ADICIONE DETALHES (OPCIONAL)"
          />
          <div class="row">
            <div class="col-lg-6 col-xs-12 mt-3">
              <label>NÚMERO DE TENTATIVAS</label>
              <select
                v-model="question.number_retakes"
                class="form-control"
              >
                <option value="3">3</option>
                <option value="5">5</option>
                <option value="7">7</option>
              </select>
            </div>
            <div class="col-lg-6 col-xs-12 mt-3">
              <label>TEMPO LIMITE</label>
              <select
                v-model="question.time"
                class="form-control"
              >
                <option value="30">30 segundos</option>
                <option value="60">60 segundos</option>
                <option value="120">120 segundos</option>
              </select>
            </div>
            <div class="col-lg-6 col-xs-12 mt-3">
              <label>PROVA</label>
              <select
                v-model="question.evaluation_id"
                class="form-control"
              >
                <template v-for="eva in evaluations">
                  <option
                    :value="eva.id"
                    :key="eva.id"
                  >{{eva.name}}</option>
                </template>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
export default {
  props: ["question_item", "index"],
  mounted() {
    this.question = this.question_item;
  },
  data: () => ({
    question: {
      title: "",
      descripton: "",
      time: 30,
      number_retakes: 3,
      evaluations: [],
      type_order: 0,
    },
  }),
  mounted() {
    axios
      .get("/recruiters/evaluations?job_id=" + this.job_id)
      .then(({ data }) => {
        this.evaluations = data.evaluations;
        if (this.evaluations.length == 0) {
          this.add();
        }
      });
  },
  methods: {
    deleteQuestion() {
      eventBus.$emit("clouse_question", this.index);
    },
  },
  validations: {
    question: {
      title: {
        required,
        minLength: minLength(5),
      },
    },
  },
};
</script>